import { cx } from '@emotion/css';
import type { ComponentProps, FC } from 'react';

export interface ODSModalBodyProps extends ComponentProps<'div'> {
  /** Remove the default modal content padding */
  padding?: boolean;
  /** @deprecated Set scrollable on containing ODSModalContainer (03/31/26) */
  scrollable?: never;
}

export const ODSModalBody: FC<ODSModalBodyProps> = ({
  className,
  padding = true,
  children,
  ...componentProps
}) => {
  return (
    <div
      data-testid="modal-body"
      className={cx(className, 'modal-body ods-modal-body', {
        'p-3': padding,
      })}
      {...componentProps}
    >
      {children}
    </div>
  );
};
